import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { PanelId } from "../../context/PanelContext";

const useOutsideAlerter = (ref, callback, excludedElementId) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        const isExcluded = Object.values(PanelId).some((id) => {
          const targetElement = event.target.closest(`#${id}`);
          return Boolean(targetElement);
        });

        const isAurocompletePopper = event.target.closest(`.MuiAutocomplete-popper`);
        const isPickerPopper = event.target.closest(`.MuiPickersPopper-root`);
        const isMobilePopper = event.target.closest(`.MuiDialog-root`);

        if (!isExcluded && !isAurocompletePopper && !isPickerPopper && !isMobilePopper) {
          callback();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback, excludedElementId]);
};

const OutsideAlerter = (props) => {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.onOutsideClick, props.excludedElementId);

  return <div ref={wrapperRef}>{props.children}</div>;
};

OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
  excludedElementId: PropTypes.string.isRequired,
};

export default OutsideAlerter;
